/**
 * @module-isolated analytics-proyectos
 * Fuente: Stock_Publico_Resumen_Proyecto + catálogo Proyectos.
 * Caché sesión 30 min + caché GAS 30 min.
 */
import { fetchProjectsAnalytics } from '../../../services/analytics-api.js';
import { getIdToken } from '../../../services/firebase-auth.js';
import { withSessionCache } from '../../../shared/utils/session-cache.js';

function key_(filters) {
  return (
    'projects:' +
    [(filters && filters.dateFrom) || '', (filters && filters.dateTo) || '', (filters && filters.projectId) || '', (filters && filters.status) || ''].join('|')
  );
}

export async function fetchProjectsDashboard(filters) {
  const force = !!(filters && filters.force);
  return withSessionCache(
    key_(filters),
    async () => {
      const token = await getIdToken(false);
      const raw = await fetchProjectsAnalytics({ ...filters, force }, token);
      return {
        sourceStatus: raw.sourceStatus || (raw.success === false ? 'error' : 'ok'),
        loadedAt: raw.generatedAt || new Date().toISOString(),
        message:
          (raw._serverCache ? 'Caché servidor (hasta 30 min). ' : '') +
          (raw.message || raw.note || 'Stock público + catálogo Proyectos.'),
        kpis: raw.kpis || [],
        funnel: raw.funnel || [],
        charts: raw.charts || {},
        table: raw.table || { columns: [], rows: [] },
        alerts: raw.alerts || [],
        alertPlaceholders: raw.alertPlaceholders || [],
        catalogs: raw.catalogs || { executives: [], projects: [], channels: [], statuses: [] }
      };
    },
    { force }
  );
}
